import React from "react";
import '../assets/styles/Project.scss';

import exterior_holiday_1 from '../assets/images/exterior_holiday_1.jpg'
import interior_holiday_1 from '../assets/images/interior_holiday_1.jpg'
import interior_holiday_2 from '../assets/images/interior_holiday_2.jpg'
import interior_holiday_3 from '../assets/images/interior_holiday_3.jpg'

function Project() {
    return(
    <div className="projects-container" id="passions">
        <h1>/ passions</h1>
        <div className="projects-grid">
            <div className="Holiday Decor">
                <img src={exterior_holiday_1} className="zoom" alt="thumbnail" width="50%"/>
                <h2>Holiday Decor</h2>
                <p></p>
            </div>
            <div className="project">
                <img src={interior_holiday_1} className="zoom" alt="thumbnail" width="50%"/>
                <h2>More Holiday Decor</h2>
                <p></p>
            </div>
            <div className="project">
                <img src={interior_holiday_2} className="zoom" alt="thumbnail" width="50%"/>
                <h2>section</h2>
                <p>description</p>
            </div>
            <div className="project">
                <img src={interior_holiday_3} className="zoom" alt="thumbnail" width="50%"/>
                <h2>section</h2>
                <p>description</p>
            </div>
            <div className="project">
                <h2>section</h2>
                <p>description</p>
            </div>
            <div className="project">
                <h2>section</h2>
                <p>description</p>
            </div>
        </div>
    </div>
    );
}

export default Project;